exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.Team__team__Pv4lc {\n  background: #fff;\n  padding-bottom: 60px; }\n\n.Team__team-member__1xyKN {\n  padding: 0 20px; }\n  .Team__team-member__1xyKN .Team__team-card__GM0w5 {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    box-shadow: 0px 0px 11px 1px rgba(0, 0, 0, 0.1); }\n    .Team__team-member__1xyKN .Team__team-card__GM0w5 .Team__team-card-name__1nik2 {\n      font-size: 22px;\n      font-weight: bold;\n      margin-top: 10px; }\n", ""]);

// exports
exports.locals = {
	"team": "Team__team__Pv4lc",
	"team-member": "Team__team-member__1xyKN",
	"team-card": "Team__team-card__GM0w5",
	"team-card-name": "Team__team-card-name__1nik2"
};